import React, {
	useState
} from "react";
import Grid from '@mui/material/Grid';
import { useSpringCarousel } from 'react-spring-carousel'
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Card from '@mui/material/Card';
import Title from '../Components/Title'

function Deck(props){

  const theme = useTheme();
	const mobile = useMediaQuery('(max-width:1000px)');


  function DeckCard(deckCardProps){
    const [hovered, setHover] = useState(false)
    return(
      <Card 
        onPointerOver={() => setHover(true)}
        onPointerLeave={() => setHover(false)}
        sx={{ 
          backgroundColor:theme.palette.quaternary.main,
          borderRadius: 5,
          outline:`solid ${hovered ? `5px` : `0px` }` ,
          outlineColor: theme.palette.quinary.main,
          outlineOffset:"-4px"
        }}
        style={{
          cursor:hovered ? 'pointer' : 'auto',
          width:mobile?'80vw':'35.4vw',
          height:mobile?'80vw':'20vw',
          overflow: "hidden",
          position: "relative",

        }}
      >
        <img draggable="false" width={"100%"} height={"100%"} src={deckCardProps.image} alt="WebP rules."></img>
      </Card>  
    ) 
  }


  const { carouselFragment } = useSpringCarousel({
    itemsPerSlide: mobile?1:2.5,
    withLoop: true,
    initialActiveItem: 3,
    items: props.data.images.map((item, index) => ({
      id: index,   
      renderItem: (
        <DeckCard key={index} image={item}></DeckCard>
      ),
    })),
  });



  return(
    <Grid
      container
      style={{
        display:"flex",
        justifyContent: "center",
      }}
    >
      <Grid
        item
      >
        <Title
          title={props.data.title}
          titleColor={theme.palette.primary.main}
          subTitle={props.data.subTitle}
          subTitleColor={theme.palette.primary.main}
        ></Title>
      </Grid>
      <Grid 
        item
        style={{
          overflow: "hidden",
          position: "relative",
          display:"flex",
          justifyContent: "center",
        }}
      >
        {carouselFragment}
      </Grid>
    </Grid>
  )
}

export default Deck;

